import { createAsyncThunk } from '@reduxjs/toolkit';
import type { RootState } from '../../store/store';
import { requireGroupId, extractError } from '../../store/thunkHelpers';
import { activityApi } from './activityApi';
import { entityActivitiesKey, type ActivitySummary } from './activityTypes';

/**
 * Fetch bulk delle attività di un'entità (GET /relationships/{groupId}/activities).
 * Una sola chiamata che sostituisce i 7 fan-out per-id della timeline (TS-59).
 * `className` DEVE essere l'FQN (es. "it.dvel.crm.core.model.Person").
 * Popola `state.activities.byEntity[fqn:classPK]`.
 */
export const fetchEntityActivities = createAsyncThunk<
  { key: string; activities: ActivitySummary[] },
  { className: string; classPK: number },
  { state: RootState; rejectValue: string }
>(
  'activities/fetchByEntity',
  async ({ className, classPK }, { getState, rejectWithValue }) => {
    try {
      const groupId = requireGroupId(getState);
      const activities = await activityApi.getEntityActivities(groupId, className, classPK);
      return { key: entityActivitiesKey(className, classPK), activities };
    } catch (err: unknown) {
      return rejectWithValue(extractError(err));
    }
  },
);
